import {HttpInterceptorFn, HttpRequest} from '@angular/common/http';
import {AuthService} from "../services/auth.service";
import {inject} from "@angular/core";

export const authInterceptor: HttpInterceptorFn = (req: HttpRequest<any>, next) => {

  const authService = inject(AuthService);
  const token = authService.getToken();

  const authReq = req.clone({
    headers: req.headers.set('Authorization', 'Bearer ' + token)
  });

  return next(authReq);
};
